<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      dark
      clipped
    >
      <v-list dense>
        <v-list-item link :to="{ name: 'Analytics' }">
          <v-list-item-action>
            <v-icon>mdi-chart-areaspline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Analyse</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Update' }">
          <v-list-item-action>
            <v-icon>mdi-update</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Mettre à jour</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Api' }">
          <v-list-item-action>
            <v-icon>mdi-api</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>API</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="primary"
      dark
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Synthèse Club40</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <router-view/>
    </v-content>

    <v-footer fixed>
      <v-spacer></v-spacer>
      <span class="caption">
        Club 40 - Classement officiel des meilleures diffusions musicales en Clubs
      </span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'App',
  data: () => ({
    drawer: null
  }),
  methods: {
    ...mapActions(['loadRanking', 'loadDates'])
  },
  created () {
    this.loadDates()
  }
}
</script>
